<template>
<!-- lazy loader -->
  <img height="150" :src="`${ api_url }/${ item.url }`" />
</template>

<script>
export default {
  props: {
    item: {
      required: true
    }
  },
  data () {
    return {
      api_url: process.env.VUE_APP_ROOT_BASE,
    }
  }
}
</script>

<style scoped>
  .cover {
    height: 100%;
  }
</style>
